import React from 'react';
import { Link, graphql } from 'gatsby';
import { useIntl } from 'gatsby-plugin-intl';

import Layout from '../components/layout';
import SEO from '../components/seo';


const BlogIndex = ({
  data: { site, allWpPost },
  location,
  pageContext: { pageNumber, nextPagePath, previousPagePath },
}) => {
  const intl = useIntl();
  const siteTitle = site.siteMetadata.title;
  const posts = allWpPost.nodes;

  return (
    <Layout location={location} title={siteTitle}>
      <SEO
        location={location}
        title={`${intl.formatMessage({ id: 'allPosts' })}${pageNumber > 1 ? ` – ${intl.formatMessage({ id: 'pageNumber' }, { pageNumber })}` : '' }`}
        lang={site.siteMetadata.locale}
        meta={process.env.GATSBY_GOOGLE_VERIFICATION ? [{ name: 'google-site-verification', content: process.env.GATSBY_GOOGLE_VERIFICATION }] : undefined}
      />
      {posts.map((post) => {
        return (
          <article key={post.uri} className="leading-relaxed mb-8">
            <header>
              <h3 className="text-xl font-semibold text-blueGray-700 hover:underline dark:text-blueGray-200" style={{ marginBottom: 0 }}>
                <Link to={post.uri}>
                  { post.title}
                </Link>
              </h3>
              <div className="opacity-70 uppercase mb-2">
                {intl.formatDate(post.date, {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
              </div>
            </header>
            <section
              dangerouslySetInnerHTML={{
                __html: post.excerpt,
              }}
            />
          </article>
        );
      })}

      <nav>
        <ul
          className="flex flex-wrap justify-between"
        >
          <li>
            {previousPagePath && (
              <Link to={previousPagePath} rel="prev" className="font-semibold hover:underline">
                ← {intl.formatMessage({ id: 'previousPage' })}
              </Link>
            )}
          </li>
          <li>
            {nextPagePath && (
              <Link to={nextPagePath} rel="next" className="font-semibold hover:underline">
                {intl.formatMessage({ id: 'nextPage' })} →
              </Link>
            )}
          </li>
        </ul>
      </nav>
    </Layout>
  )
}

export default BlogIndex

export const pageQuery = graphql`
  query WordPressPostArchive($offset: Int!, $postsPerPage: Int!) {
    site {
      siteMetadata {
        title
        locale
      }
    }
    allWpPost(
      sort: { fields: [date], order: DESC }
      limit: $postsPerPage
      skip: $offset
    ) {
      nodes {
        excerpt
        uri
        date(formatString: "MMMM DD, YYYY")
        title
        excerpt
      }
    }
  }
`
